export default __webpack_public_path__ + "static/media/no-internet.f6fe1b23.png";